import { Button, Card, CardBody, CardHeader, Center, Container, FormControl, Grid, Heading, Select, Stack } from '@chakra-ui/react';
import { Input } from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../redux/storage';
import { createUser } from '../../redux/features/userSlice';
import LoadingPage from '../LoadingPage';
import { useNavigate } from 'react-router-dom';
import MenuNavbar from '../../components/ui/Menu';
import PasswordInput from '../../components/ui/PasswordInput';
import { ROLE } from '../../utils/roles';
import Alerts from '../../components/ui/Alerts';
import userForm from '../../redux/actions/userForm';
import { useEffect } from 'react';
import clearForm from '../../redux/actions/clearForm';
import usePageTitle from '../../utils/pageTitle';

const CreateUser = () => {

    const state = useSelector((user: any) => user.userCreate)
    const userData = useSelector((states: any) => states.userForm)

    usePageTitle("Crear Usuario")

    const navigate = useNavigate()

    const dispatch = useDispatch<AppDispatch>();

    const handleCreateUserForm  = (event: any) => {

        event.preventDefault()

        dispatch(createUser(userData))
    }

    const handleChange = (event: { target: HTMLInputElement | HTMLSelectElement }) => {

        const { name, value } = event.target

        dispatch(userForm(name, value))
    }

    useEffect(() => {

        dispatch(clearForm())
    }, [])

    return (
        <Grid minHeight="100vh">
            <MenuNavbar />
            <Center>
                <Container mt={-500}>
                    {state.loading && <LoadingPage />}
                    {state.error !== '' && <Alerts message={state.error} title='Error' />}
                    {state.response.message !== '' && <Alerts message={state.response.message} type={state.response.status} title={state.response.title} />}

                    {!state.loading &&
                        <Card>
                            <Button w={150} m={5} colorScheme="brand" variant='solid' onClick={() => navigate('/user/list')}>
                                Listado de usuarios
                            </Button>
                            <CardHeader>
                                <Heading size='md'>
                                    <Center>
                                        Crear usuario
                                    </Center>
                                </Heading>
                            </CardHeader>
                            <CardBody>
                                <Stack spacing={3}>
                                    <form onSubmit={handleCreateUserForm}>
                                        <FormControl>
                                            <Input placeholder='Correo electronico' name="email" value={userData.email} onChange={handleChange} />
                                            <PasswordInput value={userData.password} onChange={(e) => handleChange(e)} />
                                            <Input placeholder='Nombre completo' name="name" value={userData.name} onChange={handleChange} mt={1} />
                                            <Select mt={1} onChange={handleChange} name="rol">
                                                <option value=''>-- Rol --</option>
                                                <option value={ROLE.Admin}>Administrador</option>
                                                <option value={ROLE.User}>Usuario</option>
                                            </Select>
                                            <Button width='100%' colorScheme='brand' variant='solid' type='submit' m={2}>Registrar</Button>
                                        </FormControl>
                                    </form>
                                </Stack>
                            </CardBody>
                        </Card>
                    }
                </Container>
            </Center>
        </Grid>
    );
}

export default CreateUser;
